module.exports = __webpack_public_path__ + "static/media/sandwich-removebg-preview.eb313eba.png";